import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a requested to return icon with a return arrow around a package.
 */
export function RequestedToReturnIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71663 14.308V11.6999C8.71856 11.3681 8.89795 11.0627 9.18683 10.8996L11.5468 9.572C11.8285 9.41488 12.1715 9.41488 12.4532 9.572L14.8132 10.8996C15.1023 11.0624 15.2819 11.368 15.2834 11.6999V14.313C15.2816 14.6448 15.1022 14.9503 14.8132 15.1133L12.4522 16.4399C12.1705 16.597 11.8275 16.597 11.5458 16.4399L9.18583 15.1123C8.89549 14.9488 8.71607 14.6412 8.71663 14.308Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12 13.0004V16.5559"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M3.99666 13.0004C3.99666 17.4205 7.57987 21.0038 12 21.0038C16.4201 21.0038 20.0033 17.4205 20.0033 13.0004C20.0033 8.5803 16.4201 4.99709 12 4.99709H4.99707"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M7.49813 2.49605L4.99709 4.99709"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M7.49813 7.49813L4.99709 4.99709"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8.84268 11.2277L12 13.0004L15.1583 11.2267"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
